export default "__VITE_ASSET__Caz2k9qo__"